import { FeatureForEdit } from "@emisgroup/query-builder-library";
import { IRadioItem } from "../../../../Common/UI/RadioButton/Types";
import { Module, PatientDetailsFeatureType } from "../../../../Types";
import { AgeTypes, DateOperator } from "./Types";

export const RangeFromDataSource = [
  {
    text: "After",
    value: DateOperator.After
  },
  {
    text: "After or on",
    value: DateOperator.AfterOrOn
  }
];

export const RangeToDataSource = [
  {
    text: "Before",
    value: DateOperator.Before
  },
  {
    text: "Before or on",
    value: DateOperator.BeforeOrOn
  }
];

export const AgeFeature: FeatureForEdit[] = [{
  featureDetail: {
    name: "age",
    displayName: "Age",
    type: "age",
    multiSelect: false,
    isDefaultColumn: true
  },
  featureType: PatientDetailsFeatureType.Age,
  module: Module.PatientDetails
}];

export const generateAgeOptions = (id: string): IRadioItem[] => {
  return [
    {
      id: `${id}-Date`,
      text: "Date",
      value: AgeTypes.DATE
    },
    {
      id: `${id}-Age`,
      text: "Age",
      value: AgeTypes.AGE
    },
    {
      id: `${id}-None`,
      text: "None",
      value: AgeTypes.NONE
    }
  ];
};
